export default __webpack_public_path__ + "static/media/SingleSource_logo_transparent rectangle.d7cbc820.svg";